import comp from "./PromptCardsV2";
export default comp;
